import React, { useEffect } from "react";
import "./about.css";
import { onNodeVisible } from "../../utils/elementUtils";

function About(props) {
    useEffect(() => {
        // Schedule observers after paint
        setTimeout(() => {
            document.querySelectorAll('#about .animate-on-scroll').forEach((el) => {
                onNodeVisible(el, () => {
                    el.classList.add('in-view');
                }, 0.1);
            });
            setNavAboutMe();
        }, 100);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function setAllInactive() {
        document.querySelectorAll("a.active").forEach((link) => {
            link.classList.remove("active");
        });
    }

    function setNavAboutMe() {
        let header = document.querySelector("#about");
        if (header) {
            onNodeVisible(
                header,
                () => {
                    setAllInactive();
                    document.querySelector("#about-me-link")?.classList.add("active");
                    document.querySelector("#about-me-link-mobile")?.classList.add("active");
                },
                0.5
            );
        }
    }

    return (
        <section id="about">
            <div className="about-container">
                <div className="about-header-container animate-on-scroll">
                    <h2 className="about-title">About Me</h2>
                    <div className="about-title-underline"></div>
                </div>

                <div className="about-content animate-on-scroll">
                    <p className="about-lead">
                        I'm Sean Brill, a Senior Software Engineer and Freelance Technical Consultant specializing in bespoke, high-performance applications across web, mobile, and emerging technologies.
                    </p>
                    <div className="about-divider"></div>
                    <p className="about-body">
                        With a degree in Information Sciences and Technology from Penn State, my career has spanned from building immersive AR/VR experiences and cross-platform mobile applications to architecting robust enterprise backend systems. Currently, as a Senior Software Engineer at Prudential Financial, I focus on integrating AI-driven insights and modernizing cloud infrastructure to deliver exceptional customer experiences.
                    </p>
                    <p className="about-body">
                        Alongside my enterprise work, I run a thriving freelance consulting practice. I partner with businesses and founders to rapidly prototype and build scalable applications from the ground up. Whether you need a dynamic frontend built in React/Next.js, a highly concurrent Node.js backend deployed to AWS/Azure, or a specialized Unity/Unreal Engine project, I bring full-stack expertise to every layer of the stack.
                    </p>
                    <p className="about-body">
                        My philosophy revolves around clear communication, rigorous system design, and deep empathy for the end-user. I provide customized solutions that transform complex visions into reality—ensuring that the software not only meets today's demands but is elegantly engineered for tomorrow's scale.
                    </p>

                    <div className="freelance-cta-card">
                        <h3 className="freelance-cta-title">Looking for a Freelance Developer?</h3>
                        <p className="freelance-cta-body">
                            I am currently accepting new clients for freelance software consulting. Whether you need a web/mobile app MVP, an AR/VR experience, or a robust cloud architecture overhaul—please contact me to discuss a project you would like to work together on.
                        </p>
                        <button
                            onClick={() => {
                                window.dispatchEvent(new CustomEvent('openContactForm'));
                            }}
                            className="primary-cta-button freelance-cta-btn"
                        >
                            Let's Work Together
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;
